import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail, ChevronRight } from 'lucide-react';
import { Button } from './Button';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Industries',
    path: '/industries'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className="fixed top-0 left-0 right-0 z-40 w-full" data-id="element-116">
      {/* Top Bar */}
      <div className="hidden lg:block bg-gray-50 border-b border-gray-100 py-2" data-id="element-117">
        <div className="container-custom flex justify-between items-center text-sm text-gray-600" data-id="element-118">
          <div className="flex items-center space-x-6" data-id="element-119">
            <a href="tel:+971529348102" className="flex items-center hover:text-blue-800 transition-colors" data-id="element-120">
              <Phone className="h-3.5 w-3.5 mr-2" data-id="element-121" />
              +971 52 934 8102
            </a>
            <a href="mailto:info@brixenconsulting.com" className="flex items-center hover:text-blue-800 transition-colors" data-id="element-122">
              <Mail className="h-3.5 w-3.5 mr-2" data-id="element-123" />
              info@brixenconsulting.com
            </a>
          </div>
          <div className="flex items-center space-x-4" data-id="element-124">
            <span data-id="element-125">DSO-IFZA, Dubai, UAE</span>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <div className={`bg-white transition-all duration-300 ${isScrolled ? 'shadow-md py-3' : 'py-5 border-b border-gray-100'}`} data-id="element-126">
        <div className="container-custom flex items-center justify-between" data-id="element-127">
          {/* Logo */}
          <Link to="/" className="flex items-center z-50" data-id="element-128">
            <div className="flex flex-col" data-id="element-129">
              <span className="text-2xl font-bold text-gray-950 tracking-tight leading-none" data-id="element-130">
                Brixen
              </span>
              <span className="text-xs font-medium text-blue-800 tracking-widest uppercase mt-0.5" data-id="element-131">
                Consulting
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-8" data-id="element-132">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium transition-colors hover:text-blue-800 ${location.pathname === link.path ? 'text-blue-800' : 'text-gray-600'}`} data-id="element-133">
                {link.name}
              </Link>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:block" data-id="element-134">
            <Link to="/contact" data-id="element-135">
              <Button size="sm" variant="primary" data-id="element-136">
                Book Consultation
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="lg:hidden p-2 text-gray-600 hover:text-gray-900 z-50" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-137">
            {isMenuOpen ? <X className="h-6 w-6" data-id="element-138" /> : <Menu className="h-6 w-6" data-id="element-139" />}
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      <div className={`fixed inset-0 bg-white z-40 transform transition-transform duration-300 ease-in-out lg:hidden pt-24 ${isMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-140">
        <div className="container-custom flex flex-col h-full pb-8" data-id="element-141">
          <nav className="flex flex-col space-y-6 text-lg font-medium mb-8" data-id="element-142">
            {navLinks.map(link => <Link key={link.name} to={link.path} className={`flex items-center justify-between py-2 border-b border-gray-50 ${location.pathname === link.path ? 'text-blue-800' : 'text-gray-900'}`} data-id="element-143">
                {link.name}
                <ChevronRight className="h-4 w-4 text-gray-400" data-id="element-144" />
              </Link>)}
          </nav>

          <div className="mt-auto space-y-4" data-id="element-145">
            <Link to="/contact" className="block w-full" data-id="element-146">
              <Button fullWidth size="lg" data-id="element-147">
                Book Consultation
              </Button>
            </Link>

            <div className="pt-6 border-t border-gray-100 space-y-3 text-sm text-gray-600" data-id="element-148">
              <a href="tel:+971529348102" className="flex items-center" data-id="element-149">
                <Phone className="h-4 w-4 mr-3 text-blue-800" data-id="element-150" />
                +971 52 934 8102
              </a>
              <a href="mailto:info@brixenconsulting.com" className="flex items-center" data-id="element-151">
                <Mail className="h-4 w-4 mr-3 text-blue-800" data-id="element-152" />
                info@brixenconsulting.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>;
}